import { createClient, FindOperation, getRequestFactory } from '@infuse/api/common';
import { Session } from './model';

const client = createClient('/rest/sessions');

export const sessionPermissions = {
  GET: 'cpms.get-session'
};

export const getSession: FindOperation<Session, string> = getRequestFactory<Session, string>(client, {
  permissionId: sessionPermissions.GET
});
